export default __webpack_public_path__ + "static/media/typing-message.257fa067.gif";